"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.List = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ListItem = require("./ListItem");
var _enums = require("../../constants/enums");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var List = exports.List = function List(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useState = (0, _react.useState)(props.value ? props.value : ''),
    _useState2 = _slicedToArray(_useState, 2),
    activeVal = _useState2[0],
    setActiveVal = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = _slicedToArray(_useState3, 2),
    offScreen = _useState4[0],
    setOffScreen = _useState4[1];
  var listRef = (0, _react.useRef)(null);
  function handleClickOutside(event) {
    if (listRef.current && !listRef.current.contains(event.target) && event.target.id != "dropdownButton" && event.target.id != "dropdownChevron") {
      props.setDisplay(false);
    }
  }
  (0, _react.useEffect)(function () {
    document.addEventListener(_enums.TargetEvent.Mousedown, handleClickOutside);
    document.addEventListener(_enums.TargetEvent.Keyup, handleClickOutside);
    return function () {
      document.removeEventListener(_enums.TargetEvent.Mousedown, handleClickOutside);
      document.removeEventListener(_enums.TargetEvent.Keyup, handleClickOutside);
    };
  }, []);
  (0, _react.useEffect)(function () {
    setActiveVal(props.value);
  }, [props.value]);
  var checkOffscreen = function checkOffscreen() {
    if (listRef && listRef.current && document) {
      var elem = listRef.current.getBoundingClientRect();
      if (elem.bottom >= document.documentElement.clientHeight) {
        setOffScreen('off');
      } else if (elem.top < 0) {
        setOffScreen('');
      }
    }
  };
  (0, _react.useEffect)(function () {
    if (window) {
      window.addEventListener('resize', checkOffscreen, {
        passive: true
      });
      window.addEventListener('scroll', checkOffscreen, {
        passive: true
      });
    }
    return function () {
      if (window) {
        window.removeEventListener('resize', checkOffscreen);
        window.removeEventListener('scroll', checkOffscreen);
      }
    };
  }, []);
  (0, _react.useEffect)(function () {
    checkOffscreen();
  }, []);
  function onSelect(event) {
    event.preventDefault();
    event.stopPropagation();
    var val = event.target.getAttribute('data-value');
    var text = event.target.textContent;
    setActiveVal(val);
    props.setValue && props.setValue(val, text);
    if (event.key === _enums.TargetEvent.Enter) {
      var parBtn = event.target.parentNode;
      var grandPar = parBtn.parentNode.previousElementSibling;
      grandPar === null || grandPar === void 0 || grandPar.focus();
    }
  }
  return /*#__PURE__*/_react["default"].createElement("ul", {
    className: "list-menu " + (props.display ? "".concat(offScreen, " display-list") : props.display === false ? "".concat(offScreen, " hide-list") : "".concat(offScreen, " display-list")),
    ref: listRef
  }, props.list.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_ListItem.ListItem, {
      value: item.value,
      text: item.text,
      activeValue: activeVal,
      key: 'list' + item.value,
      onClick: onSelect
    });
  }));
};
//# sourceMappingURL=List.js.map